import { z } from "zod"
import {
  ElementV1,
  TElementsV1,
  ElementV2,
  ElementV3,
  ElementV4,
  ElementV5,
} from "./element/element"
import {
  PageSettingsV1,
  TPageSettingsV1,
  PageSettingsV2,
  TPageSettingsV2,
  TPageSettingsV3,
  PageSettingsV3,
  PageSettingsV4,
  PageSettingsV5,
  PageSettingsV6,
} from "./pageSettings"

// Version 1 ---------------------
export type TPaywallTemplateV1 = {
  version: 1
  pageSettings?: TPageSettingsV1
  mainContent?: TElementsV1[]
  cardContent?: TElementsV1[]
}

export const PaywallTemplateV1: z.Schema<TPaywallTemplateV1> = z.object({
  version: z.literal(1),
  pageSettings: PageSettingsV1.optional(),
  mainContent: z.lazy(() => z.array(ElementV1).optional()),
  cardContent: z.array(ElementV1).optional(),
})

// Version 2 ---------------------
export type TPaywallTemplateV2 = {
  version: 2
  pageSettings?: TPageSettingsV2
  mainContent?: TElementsV1[]
  cardContent?: TElementsV1[]
}

export const PaywallTemplateV2: z.Schema<TPaywallTemplateV2> = z.object({
  version: z.literal(2),
  pageSettings: PageSettingsV2.optional(),
  mainContent: z.lazy(() => z.array(ElementV1).optional()),
  cardContent: z.array(ElementV1).optional(),
})

// Version 3 ---------------------
export type TPaywallTemplateV3 = {
  version: 3
  pageSettings?: TPageSettingsV3
  mainContent?: TElementsV1[]
  cardContent?: TElementsV1[]
}

export const PaywallTemplateV3: z.Schema<TPaywallTemplateV3> = z.object({
  version: z.literal(3),
  pageSettings: PageSettingsV3.optional(),
  mainContent: z.lazy(() => z.array(ElementV1).optional()),
  cardContent: z.array(ElementV1).optional(),
})

// Version 4 ---------------------
export const PaywallTemplateV4 = z.object({
  version: z.literal(4),
  pageSettings: PageSettingsV4.optional(),
  backgroundContent: z.array(ElementV1).optional(),
  mainContent: z.array(ElementV1).optional(),
  cardContent: z.array(ElementV1).optional(),
})

export type TPaywallTemplateV4 = z.infer<typeof PaywallTemplateV4>

// Version 5 ---------------------
export const PaywallTemplateV5 = z.object({
  version: z.literal(5),
  pageSettings: PageSettingsV4.optional(),
  backgroundContent: z.array(ElementV2).optional(),
  mainContent: z.array(ElementV2).optional(),
  cardContent: z.array(ElementV2).optional(),
})

export type TPaywallTemplateV5 = z.infer<typeof PaywallTemplateV5>

// Version 6 ---------------------
export const PaywallTemplateV6 = z.object({
  version: z.literal(6),
  pageSettings: PageSettingsV4.optional(),
  backgroundContent: z.array(ElementV2).optional(),
  mainContent: z.array(ElementV2).optional(),
  cardContent: z.array(ElementV2).optional(),
})

export type TPaywallTemplateV6 = z.infer<typeof PaywallTemplateV6>

// Version 7 ---------------------
export const PaywallTemplateV7 = z.object({
  version: z.literal(7),
  pageSettings: PageSettingsV4.optional(),
  backgroundContent: z.array(ElementV3).optional(),
  mainContent: z.array(ElementV3).optional(),
  cardContent: z.array(ElementV3).optional(),
})

export type TPaywallTemplateV7 = z.infer<typeof PaywallTemplateV7>

// Version 8 ---------------------
export const PaywallTemplateV8 = z.object({
  version: z.literal(8),
  pageSettings: PageSettingsV5.optional(),
  backgroundContent: z.array(ElementV4).optional(),
  mainContent: z.array(ElementV4).optional(),
  cardContent: z.array(ElementV4).optional(),
})

export type TPaywallTemplateV8 = z.infer<typeof PaywallTemplateV8>

// Version 9 ---------------------
export const PaywallTemplateV9 = z.object({
  version: z.literal(9),
  pageSettings: PageSettingsV5.optional(),
  backgroundContent: z.array(ElementV5).optional(),
  mainContent: z.array(ElementV5).optional(),
  cardContent: z.array(ElementV5).optional(),
})

export type TPaywallTemplateV9 = z.infer<typeof PaywallTemplateV9>

// Version 10 ---------------------
export const PaywallTemplateV10 = z.object({
  version: z.literal(10),
  pageSettings: PageSettingsV6.optional(),
  backgroundContent: z.array(ElementV5).optional(),
  mainContent: z.array(ElementV5).optional(),
  cardContent: z.array(ElementV5).optional(),
})

export type TPaywallTemplateV10 = z.infer<typeof PaywallTemplateV10>

// Version 11 ---------------------
export const PaywallTemplateV11 = z.object({
  version: z.literal(11),
  pageSettings: PageSettingsV6.optional(),
  backgroundContent: z.array(ElementV5).optional(),
  mainContent: z.array(ElementV5).optional(),
  cardContent: z.array(ElementV5).optional(),
})

export type TPaywallTemplateV11 = z.infer<typeof PaywallTemplateV11>

// Version 12 ---------------------
export const PaywallTemplateV12 = z.object({
  version: z.literal(12),
  pageSettings: PageSettingsV6.optional(),
  backgroundContent: z.array(ElementV5).optional(),
  mainContent: z.array(ElementV5).optional(),
  cardContent: z.array(ElementV5).optional(),
})

export type TPaywallTemplateV12 = z.infer<typeof PaywallTemplateV12>

// Latest ---------------------
export const PaywallTemplateLatestVersion = 11 as const
export const PaywallTemplate = PaywallTemplateV11
export type TPaywallTemplate = TPaywallTemplateV11
